import { Typography, Breadcrumb } from 'antd'
import { EditableTable } from '@/components/EditableTable'
import type { ColumnConfig, ChangeSet } from '@/components/EditableTable/types'
import { useFilials, useUpdateFilial, useCreateFilial, useDeleteFilial } from '@/hooks/useRefs'

const { Title } = Typography

export default function FilialsPage() {
  const { data: filials, isLoading, refetch } = useFilials()
  const updateMutation = useUpdateFilial()
  const createMutation = useCreateFilial()
  const deleteMutation = useDeleteFilial()

  const columns: ColumnConfig[] = [
    {
      field: 'fil_code',
      title: 'Код',
      type: 'number',
      width: 120,
      editable: false, // для существующих нельзя менять, но для новых — можно (isNew)
      validation: { required: true, min: 0 },
    },
    {
      field: 'fil_name',
      title: 'Название',
      type: 'text',
      editable: true,
      validation: { required: true },
    },
  ]

  const handleSave = async (changes: ChangeSet) => {
    // Удаление
    if (changes.deleted) {
      for (const fil_code of changes.deleted) {
        await deleteMutation.mutateAsync(Number(fil_code))
      }
    }

    // Создание новых записей
    if (changes.created) {
      for (const row of changes.created) {
        if (row.fil_code && row.fil_name) {
          await createMutation.mutateAsync({
            fil_code: Number(row.fil_code),
            fil_name: String(row.fil_name),
          })
        }
      }
    }

    // Обновление существующих
    if (changes.updated) {
      for (const [fil_code, data] of Object.entries(changes.updated)) {
        if (data.fil_name) {
          await updateMutation.mutateAsync({
            fil_code: Number(fil_code),
            data: { fil_name: data.fil_name },
          })
        }
      }
    }

    refetch()
  }

  return (
    <div>
      <Breadcrumb style={{ marginBottom: 16 }}>
        <Breadcrumb.Item>Справочники</Breadcrumb.Item>
        <Breadcrumb.Item>Филиалы</Breadcrumb.Item>
      </Breadcrumb>

      <Title level={2}>Филиалы</Title>

      <EditableTable
        columns={columns}
        dataSource={filials || []}
        rowKey="fil_code"
        loading={isLoading}
        onSave={handleSave}
        draftKey="filials"
        allowAdd={true}
        allowPaste={true}
      />
    </div>
  )
}
